import { render } from "./Permission.vue?vue&type=template&id=3395d5ca&scoped=true"
import script from "./Permission.vue?vue&type=script&lang=ts"
export * from "./Permission.vue?vue&type=script&lang=ts"

import "./Permission.vue?vue&type=style&index=0&id=3395d5ca&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3395d5ca"

export default script